module.exports = __webpack_public_path__ + "img/logo-zy.f1ba183c.png";